// extracted by mini-css-extract-plugin
export default {"paginationDiv":"Pagination_paginationDiv__rmhIt","pageItem":"Pagination_pageItem__nJDfl"};